import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=dd5227b0"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.vue?vue&type=style&index=0&id=dd5227b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports